<template>
  <div class="chat">
    <div>
      <div class="comments">
        <div v-if="comments.length">
          <p class="comment" v-for="(cval, ckey) in comments" :key="ckey">
            <span class="status" v-if="cval.status" :style="{ background: cval.status.value.background }"></span>
            <span class="user">{{ user(cval.user_id) }} - {{ time(cval.created_at) }}</span><br>
            <span class="text">{{ cval.comment }}</span>
          </p>
        </div>
        <p v-else>
          ...
        </p>
      </div>
      <div class="add">
        <textarea v-model="comment" :placeholder="_.comment + ' ...'" maxlength="500"></textarea>
        <span @click="addComment()">
          <font-awesome-icon :icon="['fas', 'plus-circle']" />
        </span>
        <div v-if="statuses.length">
          <label v-for="(sval, skey) in statuses" :key="skey" :style="{ color: sval.value.color, background: sval.value.background }">
            <input type="radio" v-model="status" :value="sval.id">{{ sval.wording.value }}
          </label>
          <span>
            Status
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API_URL } from '@/config'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
export default {
  props: ['model', 'id'],
  data() {
    return {
      statuses: [],
      users: [],
      comments: [],
      comment: '',
      status: null,
      interval: null,
    }
  },
  methods: {
    time(created) {
      const date = dayjs.utc(created);
      return date.local().format(this._.date_format_comments);
    },
    user(id) {
      let data = this.users.find(user => user.id === id);
      return (data) 
        ? data.first_name + ' ' + data.last_name
        : '';
    },
    async getComments() {
      const chat = await this.axios.get(API_URL + '/comments', {
        params: {
          model: this.model,
          id: this.id,
        }
      });
      if (!this.statuses.length) {
        this.statuses = chat.data.statuses;
        this.status = chat.data.statuses[0].id;
      }
      this.users = chat.data.users;
      this.comments = chat.data.comments;
    },
    async addComment() {
      const chat = await this.axios.post(API_URL + '/comments', {
        model: this.model,
        id: this.id,
        comment: this.comment,
        status_id: this.status,
      });
      this.statuses = chat.data.statuses;
      this.status = chat.data.statuses[0].id;
      this.users = chat.data.users;
      this.comments = chat.data.comments;
      this.comment = '';
    },
  },
  created() {
    dayjs.extend(utc);
    this.getComments();
    this.interval = setInterval(() => {
      this.getComments();
    }, 2000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
.chat {
  position: absolute;
  top: 0;
  right: 0;
  width: 460px;
  height: 100%;
  opacity: .9;
  > div {
    background: #ffffff;
    border-left: 1px solid lighten($primary-color, 80%);
    position: sticky;
    top: 0;
    height: calc(100vh - 178px);
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 92px;
    > .comments {
      grid-area: 1/1/2/2;
      overflow-y: scroll;
      .comment {
        padding: 12px 12px 0 12px;
        > .status {
          background: #eeeeee;
          display: inline-block;
          width: 13px;
          height: 13px;
          border-radius: 6px;
          margin-bottom: -2px;
          margin-right: 3px;
        }
        > .user {
          opacity: .4;
        }
        > .text {
          display: inline-block;
          padding-top: 2px;
        }
      }
    }
    > .add {
      grid-area: 2/1/3/2;
      border-top: 1px solid lighten($primary-color, 80%);
      position: relative;
      > textarea {
        outline: 0;
        border: 0;
        resize: none;
        padding: 12px;
        width: 350px;
      }
      > span {
        position: absolute;
        top: 12px;
        right: 10px;
        color: $primary-color;
        font-size: 14px;
        cursor: pointer;
      }
      > div {
        padding: 7px 9px;
        border-top: 1px dashed lighten($primary-color, 80%);
        > label {
          margin-right: 4px;
          padding: 3px 4px 3px 3px;
          background: #eeeeee;
          color: #ffffff;
          border-radius: 10px;
          > input {
            vertical-align: top;
            margin-top: 1px;
            margin-right: 2px;
          }
        }
        > span {
          float: right;
        }
      }
    }
  }
}
</style>
